export interface SharedFolderAssign {
    by?: string;
    id?: number;
}

// to single object maping
export const mapSharedFolderAssign = (data:any): SharedFolderAssign => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: SharedFolderAssign ={
        id: data.id,
        by: data.by,
       
    }
    return res;
}

// maping list objects
export const mapSharedFolderAssigns = (data:any[]): SharedFolderAssign[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapSharedFolderAssign);
}
